import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { User } from './types'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useUpdateProfileMutation = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: User) => {
      const response = await fetchWithAuth(`${URL}/profile/${data.userId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
      return response as User
    },
    onError: (error) => {
      console.error('Update profile error:', error)
      toast.error(error.message)
    },
    onSuccess: () => {
      toast.success('Profile updated')
      queryClient.invalidateQueries({ queryKey: ['profile'] })
      queryClient.invalidateQueries({ queryKey: ['adminProfile'] })
      queryClient.invalidateQueries({ queryKey: ['currentUser'] })
    },
  })
}
